export const GET_EPISODES_QUERY = `
  query GetEpisodes($installment: Int) {
    episodes(installment: $installment) {
      id
      installment
      youtubeLink
      guests
      entriesCount
      bucketPullsCount
    }
  }
`;

export const GET_EPISODE_QUERY = `
  query GetEpisode($id: ID!) {
    episode(id: $id) {
      id
      installment
      youtubeLink
      guests
      entriesCount
      bucketPullsCount
      bucketPulls {
        id
        paperName
        paperUuid
        pulledAt
        duration
        createdAt
      }
    }
  }
`;
